import { NextPage } from 'next'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import Activity from '~/components/Activity'
import { ExchangeTab } from '~/components/ExchangeTab'
import { useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import { useIsDisableTrade } from '~/state/dex/hooks'
import LidoCard from './Lido'
import Chart from './Chart'
import {
  StyledStakingPage,
  StyledContent,
  StyledContainerWithChart,
  StyledContainer,
  StyledStakingBox,
  StyledMainArea,
} from './styled'

const Staking: NextPage = () => {
  const { t } = useTranslation()

  const isDisableTrade = useIsDisableTrade()
  const toggleIpBlockedModal = useModalToggle(ApplicationModal.IP_BLOCKED)

  useEffect(() => {
    if (isDisableTrade) {
      toggleIpBlockedModal()
    }
  }, [isDisableTrade])

  return (
    <StyledStakingPage>
      <Head>
        <title>{t('meta_staking_title')}</title>
        <meta name="description" content={t('meta_staking_description')} />
        <meta name="keywords" content={t('meta_staking_keywords')} />
      </Head>
      <Header />
      <StyledContent>
        <StyledContainerWithChart>
          <Chart />
          <StyledContainer>
            <Activity />
            <StyledStakingBox root>
              <ExchangeTab />
              <StyledMainArea>
                <LidoCard />
              </StyledMainArea>
            </StyledStakingBox>
          </StyledContainer>
        </StyledContainerWithChart>
      </StyledContent>
      <Footer />
    </StyledStakingPage>
  )
}

export default Staking
